export const MIME_TYPES = {
	PDF: ['application/pdf'],
	IMAGE: ['image/bmp', 'image/jpeg', 'image/x-png', 'image/png', 'image/gif'],
};
